{ partitionAndSort } = require('../../utils')

module.exports = (
  $scope,
  $filter,
  Api,
  requests,
  staff,
  User
) ->
  $scope.user = User

  $scope.staff = staff
  $scope.requests = requests
  $scope.owners = { lock: {} }
  @Api = Api

  $scope.model = {
    showCompleted: false
  }

  $scope.assignTo = (user, request) ->
    request.assigned_to = id: user.id
    request.$update()

  $scope.onFilterAssigned = (user) ->
    if user.id
      $scope.filterAssigned = {id: user.id}
    else
      $scope.filterAssigned = undefined

  $scope.filterCompleted = (request) ->
    request.completed_date == null or $scope.model.showCompleted

  $scope.getUserEmail = (id) ->
    if $scope.owners[id] and $scope.owners.lock[id] != true
      return $scope.owners[id]

    else if $scope.owners.lock[id] != true
      $scope.owners.lock[id] = true

      Api.Users.get({id: id}).$promise.then (user) ->
        $scope.owners[id] = user
        $scope.owners.lock[id] = false

  $scope.filterStaff = staff
  $scope.filterStaff.unshift({'email': '--show everyone--', id: false})
